<template>
  <div id="About">
    <div class="banner">
      <img src="/static/images/about/m_ab_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("about.bannerText")}}</div>
        <div class="titleSub">{{$t("about.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
            <div class="box">
                <div class="boxCon">
                  <div class="detail">
                    <div class="title">{{$t("about.tit")}}</div>
                    <p>
                   {{$t("about.detail1")}}
                    </p>
                    <br>
                    <p>
                    {{$t("about.detail2")}}
                    </p>
                  </div>
                  <div class="imgBox">
                    <img src="/static/images/about/m_ab_hk.png" alt="">
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {

  }
};
</script>
<style lang="less" type="text/less">
  .el-input__inner{
    background: #f7f7f7;
    color: #999
  }
  .el-input__inner:focus{
    border-color: #27C2B4;
  }
</style>
<style scoped lang="less" type="text/less">
#About{
  margin-top: 50px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 20%;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      padding: 0 10px;
      color: #fff;
      .title{
        font-size: 3rem;
        font-weight: bold;
        position: relative;
      }
      .titleSub{
        font-size: 1.6rem;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 3rem 0;
    .con{
      width: 80%;
      margin: 0 auto;
      .box{
        .boxCon{
          // display: flex;
          // justify-content: space-between;
          // align-items:flex-start;
          position: relative;
          .imgBox{
            margin-top: 20px;
            img{
              width: 100%;
            }
          }
          .detail{
            font-size: 1.6rem;
            color: #333;
            line-height: 2.4rem;
            .title{
              font-size: 2.8rem;
              color: #333;
              font-weight: bold;
              padding-bottom: 20px;
            }
          }
          // &::before{
          //   content:'';
          //   display: inline-block;
          //   height: 1px;
          //   width: 100%;
          //   background: #e2e2e2;
          //   position: absolute;
          //   bottom: -35px;
          // }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/About/About.vue